import type { IFilterButton } from '@/creditflowresearch/ui/common/components/organisms/ButtonGroup';
import { IActiveItem } from './useFilterButtons';

export const extractActiveItems = (
  items: IFilterButton[],
): IActiveItem[] => {
  return items
    .filter((item) => item.isActive)
    .map((item) => ({ hasAccess: item.hasAccess }));
};
